import { Component, OnInit, Inject } from "@angular/core"
import {FormGroup, FormBuilder, Validators} from '@angular/forms'
import {CasoTareaModel, CasoTareaService} from 'src/app/services/casos_tareas.service'
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog'
import {TareaCasoService} from 'src/app/services/tareacaso.service'
import {MatSnackBar} from '@angular/material/snack-bar'
import {UserService} from 'src/app/services/user.service'

@Component({
  selector: 'observacion-final',
  template: `
  <div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title font-weight-bold" id="exampleModalLabel1">
      Observación Final
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      [mat-dialog-close]
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="container text-center">

    <div class="info-general-caso">
      <b>Número de Caso:</b> {{caso.numero_caso }}
      <br>
      <b>Unidad:</b> {{caso.unidad }}
      <br>
      <b>Tipo de Caso:</b> {{caso.tipo_caso }}
      <br>
      <b>Analista</b> {{caso.asignadoA }}
      <br>
      <b>Fecha de Creación:</b> {{caso.createdAt | date:"d/M/yy"}}
      <br>
      <b>Última Modificación:</b> {{ caso.updatedAt | date:"d/M/yy"}}
      <br>
      <b>Creado Por:</b> {{ caso.creadoPorc }} 
      <br>
      <b>Tareas Finalizadas:</b> {{ tareaFinalizadas }} 
    </div>

    <div class="descripcion_tarea mt-3">
      <b>Descripción: </b> {{ caso.descripcion }}
    </div>

    <form 
      [formGroup]="form" 
      class="formulario mt-5" 
    >
      <mat-form-field class="matform" appearance="outline">
        <mat-label>Observaciones</mat-label>
        <textarea matInput formControlName="observacion_final"></textarea>
      </mat-form-field>
    </form>


    <div
      class="text-center mt-4"
    >
      <button
        class="btn-guardar"
        (click)="finalizarDelTodo()"
      >Enviar observacion</button>
    </div>
  </div>
</div>

  `,
  styles:[`
    .btn-guardar{
      background-color: #051235; 
      color: white;
      border-radius: 10%;
      padding: 13px 22px;
    }
    .btn-save{
      background-color: #051235; 
      color: white;
      border-radius: 10%;
      padding: 5px 5px;
    }
    .btn-delete{
      background-color: #dc3c45; 
      color: white;
      border-radius: 10%;
      padding: 5px 5px;
    }
    b{
      font-size:14px;
    }
    .formulario{
      width:100%;
      text-align:center;
    }
    .matform{
      width: 95%;
    }
  `]
})
export class NoAprobarComentario implements OnInit {

  tareaFinalizadas: number = null

  form: FormGroup = this.fb.group({
    observacion_final: ['', Validators.required]
  })

  constructor(
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<NoAprobarComentario>,
    @Inject(MAT_DIALOG_DATA) public caso: CasoTareaModel,
    public _tareas: TareaCasoService,
    public _casos: CasoTareaService,
    public _snackBar: MatSnackBar,
    public _users: UserService
  ){}

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action)
  }

  ngOnInit(){
    this.init()
  }

  async init(){
    this._tareas.getByCaso(this.caso._id).subscribe(tareas=>this.tareaFinalizadas = tareas.length)
    this.getCreadoPor() 
  }

  async getCreadoPor(){
    this.caso.creadoPorc = (await this._users.getUserById(parseInt(this.caso.creadoPor)).toPromise()).payload.correo
  }

  async finalizarDelTodo(){
    this.dialogRef.close(this.form.value.observacion_final)
  }

}
